import { render, staticRenderFns } from "./choseMsg.vue?vue&type=template&id=4ed4f2e2&scoped=true&"
import script from "./choseMsg.vue?vue&type=script&lang=js&"
export * from "./choseMsg.vue?vue&type=script&lang=js&"
import style0 from "./choseMsg.vue?vue&type=style&index=0&id=4ed4f2e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4f2e2",
  null
  
)

export default component.exports